import SearchIndicator from './SearchIndicator';
import React from 'react';
import Head from './Head';

export function LoadingReportSpinner({ durationMsString = '00:00:00' }: { durationMsString?: string }) {
  return (
    <>
      <Head siteTitle="Laster" status="yellow" />
      <div
        style={{
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Lager rapport</div>
          <div style={{ textAlign: 'right' }}>
            <div>{durationMsString.substring(0, 8)}</div>
          </div>
        </div>
        <SearchIndicator />
      </div>
    </>
  );
}
